import api from './api';

export interface Role {
  id: number;
  name: string;
  guard_name: string;
  created_at: string;
  updated_at: string;
  permissions?: Array<{
    id: number;
    name: string;
  }>;
}

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export const roleService = {
  async getAll(): Promise<Role[]> {
    const response = await api.get('/roles');
    return unwrap<Role[]>(response);
  },
  async updatePermissions(roleId: number, permissionIds: number[]): Promise<Role> {
    const response = await api.put(`/roles/${roleId}/permissions`, {
      permission_ids: permissionIds,
    });
    return unwrap<Role>(response);
  },
};
